import { SettingsContext } from "@redotech/redo-customer-portal-app/contexts/settings";
import { Login } from "@redotech/redo-customer-portal-app/login/login";
import { useContext } from "react";
import { useSearchParams } from "react-router-dom";
import { Login as OldLogin } from "./login";
export function LoginDispatcher() {
  const settings = useContext(SettingsContext);

  const [searchParams, _] = useSearchParams();
  const previewNewLogin = searchParams.get("previewNewLogin") === "true";

  if (settings?.returns?.newLogin || previewNewLogin) {
    return <Login />;
  }

  return <OldLogin />;
}
